/* SP Article — copiar enlace + barra de progreso de lectura. */
(function () {
  if (window.__spArticleBound) return;
  window.__spArticleBound = true;

  // Copiar enlace
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sp-copy]');
    if (!btn) return;
    var share = btn.closest('[data-sp-share]');
    var url = (share && share.getAttribute('data-url')) || location.href;
    var done = function () {
      btn.classList.add('is-copied');
      var t = btn.getAttribute('aria-label');
      btn.setAttribute('aria-label', btn.getAttribute('data-label-copied') || t);
      setTimeout(function () { btn.classList.remove('is-copied'); btn.setAttribute('aria-label', t); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {});
    } else {
      var ta = document.createElement('textarea');
      ta.value = url; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(ta);
    }
  });

  // Barra de progreso de lectura
  var bar = document.querySelector('[data-sp-progress] > span');
  var article = document.querySelector('.sp-article__content');
  if (bar && article) {
    var tick = false;
    function update() {
      tick = false;
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = -rect.top;
      var pct = total > 0 ? Math.min(1, Math.max(0, scrolled / total)) : 0;
      bar.style.transform = 'scaleX(' + pct + ')';
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
})();
